export default "Décret Tertiaire Collectivités — Plan −40 % OPERAT | Solution Éco France";
